export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOAD_PROFILE = "LOAD_PROFILE";
export const LOGOUT = "LOGOUT";

export const HOME_VIDEOS_SUCCESS = "HOME_VIDEOS_SUCCESS";
export const HOME_VIDEOS_FAIL = "HOME_VIDEOS_FAIL";
export const HOME_VIDEOS_REQUEST = "HOME_VIDEOS_REQUEST";

export const SELECTED_VIDEO_REQ = "SELECTED_VIDEO_REQ";
export const SELECTED_VIDEO_SUCCESS = "SELECTED_VIDEO_SUCCESS";
export const SELECTED_VIDEO_FAIL = "SELECTED_VIDEO_FAIL";
export const SELECTED_VIDEO_ISLIKED = "SELECTED_VIDEO_ISLIKE";

export const RATE_SELECTED_VIDEO = "RATE_SELECTED_VIDEO";

export const CHANNEL_DETAILS_REQ = "CHANNEL_DETAILS_REQ";
export const CHANNEL_DETAILS_FAIL = "CHANNEL_DETAILS_FAIL";
export const CHANNEL_DETAILS_SUCCESS = "CHANNEL_DETAILS_SUCCESS";

export const VIDEO_COMMENTS_REQ = "VIDEO_COMMENTS_REQ";
export const VIDEO_COMMENTS_FAIL = "VIDEO_COMMENTS_FAIL";
export const VIDEO_COMMENTS_SUCCESS = "VIDEO_COMMENTS_SUCCESS";

export const CREATE_COMMENT_SUCCESS = "CREATE_COMMENT_SUCCESS";
export const CREATE_COMMENT_FAIL = "CREATE_COMMENT_FAIL";

export const RELATED_VIDEO_REQ = "RELATED_VIDEO_REQ";
export const RELATED_VIDEO_SUCCESS = "RELATED_VIDEO_SUCCESS";
export const RELATED_VIDEO_FAIL = "RELATED_VIDEO_FAIL";

export const SEARCH_VIDEOS_SUCCESS = "SEARCH_VIDEOS_SUCCESS";
export const SEARCH_VIDEOS_FAIL = "SEARCH_VIDEOS_FAIL";
export const SEARCH_VIDEOS_REQ = "SEARCH_VIDEOS_REQ";

export const SUBSCRIPTION_CHANNEL_SUCCESS = "SUBSCRIPTION_CHANNEL_SUCCESS";
export const SUBSCRIPTION_CHANNEL_FAIL = "SUBSCRIPTION_CHANNEL_FAIL";
export const SUBSCRIPTION_CHANNEL_REQ = "SUBSCRIPTION_CHANNEL_REQ";

export const CHANNEL_VIDEO_REQ = "CHANNEL_VIDEO_REQ";
export const CHANNEL_VIDEO_SUCCESS = "CHANNEL_VIDEO_SUCCESS";
export const CHANNEL_VIDEO_FAIL = "CHANNEL_VIDEO_FAIL";

export const USER_LIKEDVIDEO_REQ = "USER_LIKEDVIDEO_REQ";
export const USER_LIKEDVIDEO_SUCCESS = "USER_LIKEDVIDEO_SUCCESS";
export const USER_LIKEDVIDEO_FAIL = "USER_LIKEDVIDEO_FAIL";

export const SET_SUBSCRIPTION = "SET_SUBSCRIPTION";
export const SET_SUBSID = "SET_SUBSID";
